import setupOfflineWin from '../../assets/images/setupOffline_win.png'
import setupOfflineWin2x from '../../assets/images/setupOffline_win@2x.png'

interface SetupOfflineWinIconProps {
  className?: string
  alt?: string
}

/**
 * Setup Offline Windows Icon
 * Zeigt die Windows-Computer-Grafik für den Offline-Modus
 */
export const SetupOfflineWinIcon = ({
  className = '',
  alt = 'Offline Setup Windows'
}: SetupOfflineWinIconProps) => {
  return (
    <img
      src={setupOfflineWin}
      srcSet={`${setupOfflineWin2x} 2x`}
      alt={alt}
      className={className}
    />
  )
}
